import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import UserEditForm from '../../../features/cfi/user/components/UserEditForm';

export default function NewUserPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('New User')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<UserEditForm />
			</div>
		</React.Fragment>
	)
} 
